var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-box-img"},[_c('div',{staticClass:"header-logos"},[_c('img',{attrs:{"src":require("../../../assets/homes/header-logos.png"),"alt":""}})]),_c('div',{staticClass:"home-icon"},[_c('img',{attrs:{"src":require("../../../assets/homes/home-icon-bai.png"),"alt":""}})])])
}]

export { render, staticRenderFns }